function query(selector, context_or_callback, callback) {
    let context;
    if (typeof context_or_callback === 'function') {
        context = document;
        callback = context_or_callback;
    }
    else {
        context = context_or_callback || document;
    }
    if (typeof callback === 'function') {
        return Array.from(context.querySelectorAll(selector), callback);
    }
    else {
        return Array.from(context.querySelectorAll(selector));
    }
}

export { query as default, query };
